class HttpError extends Error {
  response: any;
  code: number;

  constructor(response: any) {
    super(JSON.stringify(response));
    this.name = "HttpError";
    this.code = response.status;
    this.response = response;
  }
}

export default HttpError;